import React from "react";
const Auth0Context = React.createContext(null);
export default Auth0Context;
